import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { connect, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { MapContext } from 'os-elements';
import Button from 'client/components/aria/Button/Button';
import { VALID_MODES } from './RecentreButton.mode';
import mapModeIsValid from '../validateModes';
import { setTimedContent } from 'client/store/alertSlice/alertSlice';
import styles from './RecentreButton.module.scss';

const RecentreButton = ({
    mapMode
}) => {
    const intl = useIntl();
    const { map } = useContext(MapContext);
    const dispatch = useDispatch();

    if (!mapModeIsValid(mapMode, VALID_MODES)) {
        return null;
    }

    const handleRecentre = (e) => {
        const geometry = map?.getLayerById('aoi')?.getSource().getFeatures()[0].getGeometry();
        if (geometry) {
            map.getView().fit(geometry, { padding: [50, 50, 50, 50] });
            dispatch(setTimedContent(
                {
                    content: intl.formatMessage({ id: 'mapToolbar.recentreButton.notification' }),
                    severity: 'info'
                }

            ));
        }
        e.currentTarget.blur(); // lose focus (stops button staying yellow)
    };

    return <Button
        className={ styles.recentreButton }
        data-testid="mapToolBar.recentre.button"
        onClick={handleRecentre}
        variant="info"
    >
        { intl.formatMessage({ id: 'mapToolbar.recentreButton.text' }) }
    </Button>;
};

RecentreButton.propTypes = {
    mapMode: PropTypes.array
};

const mapStateToProps = state => {
    const { map } = state;
    return {
        mapMode: map?.mode || []
    };
};

export default connect(mapStateToProps)(RecentreButton);
